import { useEffect } from 'react';

import { useAtom } from 'jotai';

import {
  selectOnboardingStepAtom,
  showOnboardingAtom,
} from '../../modules/patientList/atoms';
import { useGetEvents } from '../../react-query/useEvents';
import { usePreferences } from '../../react-query/usePreferences';
import {
  FeatureFlagType,
  PracticeFeatureFlagKey,
  useFeatureFlag,
} from '../user';

export const useOnboarding = () => {
  const isOnboardingEnabled = !!useFeatureFlag(
    PracticeFeatureFlagKey.ONBOARDING_ENABLED,
    FeatureFlagType.PRACTICE,
  )?.value;

  const [showOnboarding] = useAtom(showOnboardingAtom);

  const [currentSlide, setCurrentSlide] = useAtom(selectOnboardingStepAtom);

  const localStorageVal = localStorage.getItem('jotai-onboarding-step');

  useEffect(() => {
    if (!localStorageVal) setCurrentSlide(0);
  }, [localStorageVal, setCurrentSlide]);

  const { data: preferences } = usePreferences();
  const isOnboardingPopupEnabled = !!preferences?.onboardingPopupEnabled;

  const onboardingEvent = useGetEvents(
    { name: 'user.onboarding.completed' },
    {
      enabled: false || isOnboardingPopupEnabled,
    },
  );

  return Boolean(
    isOnboardingEnabled &&
      ((!onboardingEvent.isLoading &&
        currentSlide !== -1 &&
        isOnboardingPopupEnabled) ||
        showOnboarding),
  );
};
